import React, { createContext, useReducer } from "react"
import { AuthProvider } from "react-use-auth"
import { navigate } from "gatsby"
import configurationReducer from "./configurationReducer"
import productReducer from "./productReducer"
import keyReducer from "./keyReducer"
import queryReducer from "./queryReducer"
import quoteReducer from "./quoteReducer"
import userReducer from "./userReducer"

const initialConfigState = {
  xkit: "",
  // activeFunctionNone: "",
  // activeFunctionActive: "",
  // activeFunctionActivePlus: "",
  hcuSwitch: "no",
  cturn: "",
  boatLength: "",
  hullType: "",
  starboardInterceptors: "",
  centerInterceptors: "",
  steeringInterceptors: "",
  allSpeedFins: "",
  mainCPCable: "",
  servoCable: "",
  finServoCable: "",
  hcuRcuCables: "",
  finHcuRcuCables: "",
  hcuHcuCables: "",
  softwareComfort: "no",
  softwareComfortPlus: "no",
  softwareDynamic: "no",
  softwareDynamicPlus: "no",
  softwareProfessional: "no",
  softwareProfessionalPlus: "no",
  softwareNoSoftware: "no",
  softwareCruise: "no",
  softwareCruiseProfessional: "no",
  softwareUltimate: "no",
  softwareUltimateProfessional: "no",
  softwareCatamaranProfessional: "no",
}

var initialUser = []
typeof window !== "undefined"
  ? (initialUser = JSON.parse(localStorage.getItem("humphree-user")) || [])
  : (initialUser = [])

export const ConfigurationContext = createContext()
export const ProductContext = createContext()
export const KeyContext = createContext()
export const QueryContext = createContext()
export const QuoteContext = createContext()
export const UserContext = createContext()

export const Store = props => {
  const configuration = useReducer(configurationReducer, initialConfigState)
  const products = useReducer(productReducer, [])
  const keys = useReducer(keyReducer, [])
  const query = useReducer(queryReducer, {})
  const quote = useReducer(quoteReducer, [])
  const user = useReducer(userReducer, initialUser)
  return (
    <AuthProvider
      navigate={navigate}
      auth0_domain="humphree.eu.auth0.com"
      auth0_client_id="lhdvr9FIfip6wASEx4gUbjEBQqxdWGIE"
    >
      <UserContext.Provider value={user}>
        <ConfigurationContext.Provider value={configuration}>
          <ProductContext.Provider value={products}>
            <KeyContext.Provider value={keys}>
              <QueryContext.Provider value={query}>
                <QuoteContext.Provider value={quote}>
                  {props.children}
                </QuoteContext.Provider>
              </QueryContext.Provider>
            </KeyContext.Provider>
          </ProductContext.Provider>
        </ConfigurationContext.Provider>
      </UserContext.Provider>
    </AuthProvider>
  )
}
